//
import React from "react";
import numeral from "numeral";
//component
import { Table, Tag } from "antd";
//redux
//selector
//actions
//utils
import { getTime } from "util/time.function";
//hook
import { useDataFinance } from "hook/finance/supporter/useDataFinance";
//str
import { STATUS_PAYMENT } from "store/string";

const HistoryTableClone = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useDataFinance();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Thời gian",
      dataIndex: "setAt",
      key: "setAt",
      render: (value) => (
        <span style={{ fontSize: 12 }}>
          {getTime(value, "DD/MM/YYYY HH:mm:ss")}
        </span>
      ),
    },
    {
      title: "Mã Tracker",
      dataIndex: "tracker",
      key: "tracker",
      render: (value) => <Tag style={{ fontSize: 10 }}>{value}</Tag>,
    },
    {
      title: "phần trăm hoàn thành (%)",
      dataIndex: "percentComplete",
      key: "percentComplete",
      render: (value) => <>{value}</>,
    },
    {
      title: "Số tiền nhận được (vnd)",
      dataIndex: "amount",
      key: "amount",
      render: (value) => <>{numeral(value).format("0,0")}</>,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value) => getStattus(value),
    },
  ];

  const getStattus = (value) => {
    const select = STATUS_PAYMENT?.find((s) => s?.value === value);
    const color = select?.color;
    const label = select?.label;
    return (
      <Tag color={color} style={{ borderRadius: 20 }}>
        {label}
      </Tag>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Table
      loading={data === null}
      columns={columns}
      dataSource={data}
      pagination={{ pageSize: 20 }}
      scroll={{ x: "fit-width" }}
      rowKey={"id"}
    />
  );
};
export default HistoryTableClone;
